import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddPackageComponent } from './add-package/add-package.component';
import { PackagesLogComponent } from './packages-log/packages-log.component';
import { PackageScheduleComponent } from './package-schedule/package-schedule.component';
import { AddImageAltComponent } from './add-image-alt/add-image-alt.component';


const routes: Routes = [
    {
        path: '',
        redirectTo: '/add',
        pathMatch: 'full'
      },
    {
      path: 'add',
      component: AddPackageComponent
    },
    {
      path: 'edit/:id',
      component: AddPackageComponent
    },
    {
      path: 'image-alt/:id',
      component: AddImageAltComponent
    },
    {
      path: 'list',
      component: PackagesLogComponent
    },
    {
      path: 'schedule/:id',
      component: PackageScheduleComponent
    },
    {
      path: 'schedule',
      component: PackageScheduleComponent
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PackagesRoutingModule { }
